import React from 'react';
import { createIcon } from './create-icon';
import './icon-circled-checkmark.scss';

export const IconCircledCheckmark = createIcon(<div className="icon-circled-checkmark" />);
